import React, { useState, useContext, useEffect } from 'react';

import DashboardUI from './DashboardUI';
import { apiCaller } from '../../../services/AxiosInstance';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getCategories, getVenues } from '../../../services/CommonServices';

const Homev2 = () => {
    const [reportData, setReportData] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterLoading, setFilterLoading] = useState(false);
    const startOfMonth = moment().startOf("month").format("MM/DD/YYYY");
    const endOfMonth = moment().endOf("month").format("MM/DD/YYYY");
    const currentYear = moment().year(); // ⬅️ current year

    const [filters, setFilters] = useState({
        startDate: startOfMonth,
        endDate: endOfMonth,
        artForms: "",
        venue: "",
        year: currentYear,
        // add whatever filters you want
    });

    const getReportData = async (overrideFilters = null) => {
        // Simulate data fetching   
        const finalFilters = overrideFilters || filters;
        
        // Set filter loading if filters are being overridden (i.e., user changed filters)
        if (overrideFilters) {
            setFilterLoading(true);
        }

        try {
            const response = await apiCaller({
                method: 'get', url: 'master/dashboard', params: {
                    ...finalFilters, startDate: moment(finalFilters.startDate).format("YYYY/MM/DD"), endDate: moment(finalFilters.endDate).format("YYYY/MM/DD")
                },
            });
            if (response?.data?.success) {
                setReportData(response?.data?.data || {});
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setLoading(false);
            setFilterLoading(false);
        }
    };
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCategories());
        dispatch(getVenues());
        getReportData();
    }, []);
    return !loading ? (
        <DashboardUI reportData={reportData} refreshData={() => getReportData()}
            onFilterChange={(newFilters) => {
                setFilters(newFilters);
                getReportData(newFilters);
            }}
            filters={filters} 
            filterLoading={filterLoading} />
    ) : null;
}
export default Homev2;